export type StatusCardKey =
  | "TOTAL"
  | "INCOMING_FAX"
  | "COMPLETED"
  | "RESCHEDULED"
  | "NO_SHOW"
  | "CANCELLED"
  | "PENDING"
  | "CONFIRMED"
  | "INSTANT"
  | "CANCELLED"
  | "NO_SHOW"
  | "CHECKED_IN"
  | "IN_EXAM"
  | "SCHEDULED"
  | "INTAKE_COMPLETED"
  | "COMPLETED"
  | "IN_PROGRESS";

export const COSIGN_PIN_NOTICE =
  "Action needed: set your Co-Sign PIN before you can co-sign visit notes.";
export const COSIGN_PIN_NOTICE_ACTION_LABEL = "Set PIN";
